import all from './all';
import allBulk from './allBulk';
import store from './store';
import bulkStore from './bulkStore';
import destroy from './destroy';
import update from './update';
import search from './search';
import batchUpdate from './batchUpdate';

export default {
  all,
  allBulk,
  store,
  destroy,
  update,
  search,
  bulkStore,
  batchUpdate,
};



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/index.js